let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iDz3K")).then(() => parcelRequire('aAIpa'));